"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultValueRenderer = exports.getValueTextColor = void 0;
const react_1 = __importStar(require("react"));
const constans_1 = require("../helpers/constans");
const helpers_1 = require("../../../Grid/cellRenderers/helpers");
const Icon_1 = require("../../../Icon");
const StackView_1 = require("../../../StackView");
const Text_1 = require("../../../Text");
const Tooltip_1 = require("../../../Tooltip");
const View_1 = require("../../../View");
function getValueTextColor({ disabled, isPlaceholder }) {
    if (disabled || isPlaceholder) {
        return Text_1.TEXT_VIEW.light;
    }
    return Text_1.TEXT_VIEW.primary;
}
exports.getValueTextColor = getValueTextColor;
const TextWithTooltip = ({ disabled, text, isPlaceholder }) => {
    const ref = (0, react_1.useRef)(null);
    return (0, Tooltip_1.useTooltip)({
        maxWidth: constans_1.DEFAULT_MAX_WIDTH_COMBOBOX_TOOLTIP,
        renderContent: () => react_1.default.createElement(helpers_1.TooltipText, { size: Text_1.TEXT_SIZE.s }, text),
        render: (tooltipProps) => {
            return (react_1.default.createElement(Text_1.Text, Object.assign({}, tooltipProps, { ref: ref, view: getValueTextColor({ disabled, isPlaceholder }), truncate: true, onMouseEnter: (0, helpers_1.onMouseEnterHandlerDecorator)(tooltipProps.onMouseEnter, ref), onMouseLeave: tooltipProps.onMouseLeave }), text));
        }
    });
};
function defaultValueRenderer({ icon, disabled, placeholder, formattedText, value }) {
    const displayPlaceholder = !!placeholder && (!value || value === 0);
    return (react_1.default.createElement(StackView_1.StackView, { testId: "combobox-value", align: StackView_1.STACK_ALIGN.center, spaceFill: View_1.SPACE_FILL.all, gap: StackView_1.STACK_GAP.s },
        icon && react_1.default.createElement(Icon_1.Icon, { src: icon, disabled: disabled }),
        react_1.default.createElement(TextWithTooltip, { text: displayPlaceholder ? placeholder : formattedText, isPlaceholder: displayPlaceholder, disabled: disabled })));
}
exports.defaultValueRenderer = defaultValueRenderer;
//# sourceMappingURL=defaultValueRenderer.js.map